<template>
    <div>
        <Loading/>
        <MenuInterno/>
        <span><strong>- OBRAS <i class="fas fa-chevron-right"></i> LISTAGEM
      <span v-if="paginaTop != ''"><i class="fas fa-chevron-right"></i> {{paginaTop}}</span> </strong></span>

        <div v-if="listagem == 'listagem'">
            <div class="text-right mb-2">
                <button class="btn btn-sm btn-success" @click="viewAdicionar">Adicionar Obras</button>
            </div>
            <table id="tabela" class="table table-striped table-responsive-sm">
                <thead>
                <tr>
                    <th>Id</th>
                    <th>Número</th>
                    <th>Objeto</th>
                    <th>Descrição</th>
                    <th>Ações</th>
                </tr>
                </thead>
            </table>
            <!-- <div style="height:700px;">
              <div id="grid-obras" style="width:100%; height:100%; background-color:white;"></div>
            </div> -->
        </div>

        <div v-else-if="listagem == 'cadastro'">
            <ObrasCadastro/>
        </div>

        <div v-else-if="listagem == 'editar'">
            <ObrasEditar :id="id"/>
        </div>

    </div>
</template>

<script>
    import MenuInterno from '../menu-interno/MenuInterno.vue'
    import ObrasCadastro from '../obras/ObrasCadastro.vue'
    import ObrasEditar from '../obras/ObrasEditar.vue'
    import Loading from '../login/Loading'

    var gridObras;

    export default {
        name: 'Obras',
        data() {
            return {
                listagem: 'listagem',
                paginaTop: '',
                dados: null
            }
        },
        components: {
            MenuInterno,
            ObrasCadastro,
            ObrasEditar,
            Loading
        },
        methods: {
            viewAdicionar() {
                this.listagem = 'cadastro';
                this.paginaTop = 'ADICIONAR OBRA'
                $('#tabela').parents('div.dataTables_wrapper').first().hide();
            }

        },
        mounted: function () {

            let thiss = this;
            let swall = this.$swal;

            let tabela = $('#tabela').DataTable({
                "oLanguage": {
                    "sSearch": "Pesquisar:",
                    "sEmptyTable": "Nenhum dado para exibição",
                    "sZeroRecords": "Nenhum dado encontrado",
                    "oPaginate": {
                        "sNext": "Próximo",
                        "sPrevious": "Anterior",
                    },
                    "sLengthMenu": "Mostrar _MENU_ dados",
                    "sInfoFiltered": " - (filtrado de _MAX_ dados)",
                    "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ dados",
                },

                "ajax": {
                    "url": axios.defaults.baseURL+"/api/sist-obras/obras",
                    dataSrc: '',
                    headers: {
                        'Authorization': `Bearer ${pegaToken()}`
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        API.geraNovoTokenDatatable(jqXHR);
                    }
                },

                "columns": [
                    {"data": "o01_id", visible: false},
                    {"data": "o01_numero"},
                    {"data": "o01_objeto"},
                    {"data": "o01_descricao"},
                    {
                        targets: [4],
                        width: '10%',
                        orderable: false,
                        mData: data => criarBotoes(data.o01_id)
                    }
                ],
                'fnDrawCallback': function () {

                    $('.editar').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;
                        thiss.listagem = 'editar'
                        thiss.paginaTop = 'EDITAR'
                        $('#tabela').parents('div.dataTables_wrapper').first().hide();
                    })
                    $('.excluir').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;

                        swall({
                            title: "Atenção!",
                            text: "Deseja realmente excluir a Obra selecionada?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: 'Sim',
                            cancelButtonText: "Não!"
                        })
                            .then(
                                function () {
                                    API.enviarRequisicao('delete', '/api/sist-obras/obras/'+thiss.id)
                                        .then(
                                            swall('Atenção', 'A Obra foi deletada com sucesso', 'success')
                                                .then(
                                                    function () {
                                                        history.go(0);
                                                    }
                                                )
                                        )
                                        .catch(error => {
                                            swall('Erro', 'A Obra está sendo usado em Medições', 'error')
                                        });
                                },
                                function () {
                                    return false;
                                });

                    })

                }
            });

            function pegaToken() {
                return Store.getters.pegaAccessToken;
            }

            function criarBotoes(id, ctrl) {
                if (ctrl != null) {
                    return '<a href="#" class="btnEditar' + ctrl + ' btn btn_editar_rh btn-default btn-sm">' +
                        '<i class="fa fa-edit" data-toggle="tooltip" title="Editar"></i>' +
                        '</a>' +
                        '<a href="#" data-id="' + id + '" class="btn btn-sm btn-info' + ctrl + ' btn btn-default btn-sm">' +
                        '<i class="fa fa-trash" data-toggle="tooltip" title="Deletar"></i>' +
                        '</a>';
                } else {
                    return "<button class='btn btn-sm editar' data-id='" + id + "'><i class='fa fa-edit text-info' ></i></button>" +
                        "<button class='btn btn-sm excluir' data-id='" + id + "'><i class='fa fa-trash text-danger'></i></button>";
                }
            }

            // axios
            //   .get('http://192.168.1.17:8085/api/sist-obras/obras/dhtmlx')
            //   .then(response => {
            //     this.dados = response.data
            //     gridObras.parse(this.dados, "json");

            //     let thiss = this;
            //     let swall = this.$swal;

            //     $('.hdrcell').css('text-align', 'center');

            //     $('.editar').on('click', function(){
            //       var dados = $(this).data('id');
            //       thiss.id = dados;
            //       thiss.listagem = 'editar';
            //       thiss.paginaTop = 'EDITAR';
            //     })

            //     $('.excluir').on('click', function(){
            //       var dados = $(this).data('id');
            //       thiss.id = dados;

            //       swall({
            //         title: "Atenção!",
            //         text: "Deseja realmente excluir a Obra selecionada?",
            //         type: "warning",
            //         showCancelButton: true,
            //         confirmButtonText: 'Sim',
            //         cancelButtonText: "Não!"
            //       })
            //       .then(
            //           function () {
            //             axios
            //             .delete("http://192.168.1.17:8085/api/sist-obras/obras/"+thiss.id)
            //             .then(
            //                swall('Atenção', 'A Obra foi deletada com sucesso', 'success')
            //                .then(
            //                   function () {
            //                     history.go(0);
            //                   }
            //                 )
            //             )
            //             .catch(error => {
            //               swall('Erro', 'A Obra está sendo usado em Medições', 'error')
            //             })

            //           },
            //           function () {
            //             return false;
            //           });

            //     })
            //   });

            // gridObras = new dhtmlXGridObject('grid-obras');
            // gridObras.setImagePath("libs/imgs/");
            // gridObras.setHeader("Código, Número, Objeto,Descrição, Ações");
            // gridObras.setInitWidths("70,90,440,280,120");
            // gridObras.setColAlign("left,left,left,left,center");
            // gridObras.setColTypes("ro,ro,ro,ro,ro");
            // gridObras.setColSorting("int,int,str");

            // gridObras.attachEvent("onRowCreated",function(id){
            //   this.cells(id,4).setValue("<button class='btn btn-sm editar' data-id='"+id+"'><i class='fa fa-edit text-info' ></i></button><button class='btn btn-sm excluir' data-id='"+id+"'><i class='fa fa-trash text-danger'></i></button>");
            //   return true;
            // });
            // gridObras.attachHeader("&nbsp;,#text_filter,#text_filter,#text_filter,&nbsp;");
            // // gridObras.enableSmartRendering(true,50);

            // gridObras.init();
            // gridObras.setColumnHidden(0,true);


        }

    }


</script>

<style scoped>
    a {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }

</style>

